import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../customHooks/queries/api";

export const getParameters = createAsyncThunk(
    'parametes/allParameters',
    async () => {
        const responses = await Promise.all([
            api.get(`/api/v1/parametros_react/ATENCION/LUGAR_ATENCION`),
            api.get(`/api/v1/parametros_react/ATENCION/DOLOR_BUCAL`),
            api.get(`/api/v1/parametros_react/ATENCION/DESVIO_BUCAL`),
            api.get(`/api/v1/parametros_react/ATENCION/RUIDO_ARTICULAR`),
            api.get(`/api/v1/parametros_react/ATENCION/LUXACION_BUCAL`),
            api.get(`/api/v1/parametros_react/ATENCION/PERFIL_FACIAL`),
            api.get(`/api/v1/parametros_react/ATENCION/POSTURA_LABIAL`),
            api.get(`/api/v1/parametros_react/ATENCION/RESPIRACION`),
            api.get(`/api/v1/parametros_react/ATENCION/AMIGDALA`),
            api.get(`/api/v1/parametros_react/ATENCION/PLACA_BACTERIANA`),
            api.get(`/api/v1/parametros_react/ATENCION/TARTARO`),
            api.get(`/api/v1/parametros_react/ATENCION/SALIVA`),
            api.get(`/api/v1/parametros_react/ATENCION/MOLAR_DER`),
            api.get(`/api/v1/parametros_react/ATENCION/MOLAR_IZQ`),
            api.get(`/api/v1/parametros_react/ATENCION/CANINO_DER`),
            api.get(`/api/v1/parametros_react/ATENCION/CANINO_IZQ`),
            api.get(`/api/v1/parametros_react/ODONTOGRAMA/PIEZA_DENTAL`),
            api.get(`/api/v1/parametros_react/ODONTOGRAMA/DIAGNOSTICO`),
            api.get(`/api/v1/parametros_react/ODONTOGRAMA/TRATAMIENTO`)
        ]);

        return {
            placesAtention: responses[0].data,
            painMout: responses[1].data,
            deviationMout: responses[2].data,
            noiseArticulateMout: responses[3].data,
            dislocationMout: responses[4].data,
            faceProfile: responses[5].data,
            positionLips: responses[6].data,
            breathing: responses[7].data,
            amygdala: responses[8].data,
            bacterialPlaque: responses[9].data,
            tartaro: responses[10].data,
            saliva: responses[11].data,
            rightMolar: responses[12].data,
            leftMolar: responses[13].data,
            rightCannine: responses[14].data,
            leftCannine: responses[15].data,
            toothPiece: responses[16].data,
            diagnosis: responses[17].data,
            treatment: responses[18].data
        }
    }
);

export const getInstructions = createAsyncThunk(
    'parametes/allInstructions',
    async () => {
        const responses = await Promise.all([
            api.get(`/api/v1/parametros_react/INSTRUCCIONES`),
        ]);
        return {
            instructions: responses[0].data,
        }
    }
);

export const createParametros = createAsyncThunk(
    'parametes/createParametros',
    async (data) => {
        const responses = await api.post(`/api/v1/parametros_react/ODONTOGRAMA`, data);
        return responses.data;
    }
);

const initialState = {
    status: "idle",
    error: null,
    placesAtention: [],
    painMout: [],
    deviationMout: [],
    noiseArticulateMout: [],
    dislocationMout: [],
    faceProfile: [],
    positionLips: [],
    breathing: [],
    amygdala: [],
    bacterialPlaque: [],
    tartaro: [],
    saliva: [],
    rightMolar: [],
    leftMolar: [],
    rightCannine: [],
    leftCannine: [],
    toothPiece: [],
    diagnosis: [],
    treatment: [],
};

export const parametersSlice = createSlice({
    name: "parameters",
    initialState,
    reducers:{},
    extraReducers(builder){
        builder
            .addCase(getParameters.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getParameters.fulfilled, (state, action) => {
                state.status = "succeed";
                state.placesAtention = action.payload.placesAtention;
                state.painMout = action.payload.painMout;
                state.deviationMout = action.payload.deviationMout;
                state.noiseArticulateMout = action.payload.noiseArticulateMout;
                state.dislocationMout = action.payload.dislocationMout;
                state.faceProfile = action.payload.faceProfile;
                state.positionLips = action.payload.positionLips;
                state.breathing = action.payload.breathing;
                state.amygdala = action.payload.amygdala;
                state.bacterialPlaque = action.payload.bacterialPlaque;
                state.tartaro = action.payload.tartaro;
                state.saliva = action.payload.saliva;
                state.rightMolar = action.payload.rightMolar;
                state.leftMolar = action.payload.leftMolar;
                state.rightCannine = action.payload.rightCannine;
                state.leftCannine = action.payload.leftCannine;
                state.toothPiece = action.payload.toothPiece;
                state.diagnosis = action.payload.diagnosis;
                state.treatment = action.payload.treatment;
            })
            .addCase(getParameters.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});

export default parametersSlice.reducer;
export const getPlacesAtention = (state) => state.parameters.placesAtention;
export const getPainMout = (state) => state.parameters.painMout;
export const getDeviationMout = (state) => state.parameters.deviationMout;
export const getNoiseArticulateMout = (state) => state.parameters.noiseArticulateMout;
export const getDislocationMout = (state) => state.parameters.dislocationMout;
export const getFaceProfile = (state) => state.parameters.faceProfile;
export const getPositionLips = (state) => state.parameters.positionLips;
export const getBreathing = (state) => state.parameters.breathing;
export const getAmygdala = (state) => state.parameters.amygdala;
export const getBacterialPlaque = (state) => state.parameters.bacterialPlaque;
export const getTartaro = (state) => state.parameters.tartaro;
export const getSaliva = (state) => state.parameters.saliva;
export const getRightMolar = (state) => state.parameters.rightMolar;
export const getLeftMolar = (state) => state.parameters.leftMolar;
export const getRightCannine = (state) => state.parameters.rightCannine;
export const getLeftCannine = (state) => state.parameters.leftCannine;
export const getToothPiece = (state) => state.parameters.toothPiece;
export const getDiagnosis = (state) => state.parameters.diagnosis;
export const getTreatment = (state) => state.parameters.treatment;
export const getParametersStatus = (state) => state.parameters.status;
export const getParametersError = (state) => state.parameters.error;